import { render, staticRenderFns } from "./ReferAFriend.vue?vue&type=template&id=5cf7896c&"
import script from "./ReferAFriend.vue?vue&type=script&lang=ts&"
export * from "./ReferAFriend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports